export default __webpack_public_path__ + "static/media/github.1a3193a1.svg";